import { all } from 'redux-saga/effects';

import access from './access';
import profile from './profile';
import token from './token';
import orgUser from './orgUser';

export default function* rootSaga() {
  yield all([profile(), access(), token(), orgUser()]);
}
